import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import { i18n } from '../../domain/index'
import css from './reminder.css'

interface Props {
  readonly isOpen: boolean
  readonly onSnooze: (timeInMinutes: number) => void
  readonly onCancel: () => void
}

export function SnoozeDialog({ isOpen, onSnooze, onCancel }: Props) {
  const onSelectSnoozeTime = (timeInMinutes: number) => {
    onSnooze(timeInMinutes)
    onCancel()
  }

  return (
    <Dialog open={isOpen}>
      <div className={css.centered}>
        <DialogTitle>{i18n.t('admin.reminders.snooze')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Button onClick={() => onSelectSnoozeTime(5)}>{i18n.t('admin.reminders.snoozeTimes.five')}</Button>
            <Button onClick={() => onSelectSnoozeTime(15)}>{i18n.t('admin.reminders.snoozeTimes.fifteen')}</Button>
            <Button onClick={() => onSelectSnoozeTime(30)}>{i18n.t('admin.reminders.snoozeTimes.thirty')}</Button>
            <Button onClick={() => onSelectSnoozeTime(60)}>{i18n.t('admin.reminders.snoozeTimes.sixty')}</Button>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color='primary'>
            {i18n.t('confirmModal.cancelButtonText')}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  )
}
